import Loadable from "react-loadable";

export const PromotePitchButton = Loadable({
  loader: () => import("../../../../modules/manage-pitch").then((module) => module.PromotePitchButton) as Promise<any>,
  loading: () => null,
});
